import { useParams } from "react-router-dom";
import { OrderProvider } from "contexts/OrderContext";
import OrderDetailsBanner from "Components/Order/ordersTabs/OrderDetailsBanner";
import OrderDetailsTabs from "Components/Order/ordersTabs/OrderDetailsTabs";
import BackButton from "Components/shared/BackButton";
import { useRTL } from "hooks/isRTL";

const OrderDetailsPage = () => {
  const { orderId } = useParams();
  const { t } = useRTL();

  return (
    //lready
    <div style={{ padding: "50px" }}>
      <OrderProvider orderId={orderId}>
        <BackButton text={t("backToOrdersList")} />

        <OrderDetailsBanner />
        <OrderDetailsTabs />
      </OrderProvider>
    </div>
  );
};

export default OrderDetailsPage;
